export const WHATSAPP_NUMBER = "919820032877";
export const PHONE_DISPLAY = "+91 98200 32877";
export const PHONE_TEL = "tel:+919820032877";
export const BUSINESS_HOURS = "11 AM – 7 PM, Monday to Friday";
export const OFFICE_ADDRESS = "Veena Tower, Mumbai 400080";
export const WHATSAPP_MESSAGE =
  "Hi TheBombayHouse! I'd like to discuss launching my brand on marketplaces.";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;
export const ADMIN_EMAIL = "amit@thebombayhouse.com";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const scrollToSection = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -96 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const isBusinessHours = () => {
  const ist = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  const day = ist.getDay();
  const hour = ist.getHours();
  return day >= 1 && day <= 5 && hour >= 11 && hour < 19;
};

export const PACKAGES = [
  "The Roadmap — ₹30,000",
  "Guided Launch — ₹25,000/mo",
  "Full Accountability — ₹5,00,000/yr",
  "Not sure yet",
];
